<template>
    <div class="home center-content">
        <b-card tag="div">
            <f-project-header v-if="hasProjects" />
            <f-usage-cards v-if="hasProjects && hasToken" />
            <!-- <f-usage-cards /> -->
            <!-- <f-chartData v-if="!emk.isLoading && isFuga" /> -->
            <!-- <f-chartData  /> -->
            <div class="card text-center">
                <svg-rocket-launch/>
                <div v-if="isLoggedIn">
                    <h3 class="h3"><strong>Instances tailored to your needs!</strong></h3>
                    <p class="introduction-text">Launch an instance and experience its power first hand.</p>
                    <a href="#" class="btn btn-lg btn-cta mt-3" @click.prevent="findRegistrationStep('/instance/create')" v-if="!hasTenant">Create Instance</a>
                    <router-link :to="{name: 'instance-create'}" class="btn btn-lg btn-cta mt-3 mb-4" v-else>Create instance</router-link>
                </div>
                <div v-else>
                    <h3 class="h3"><strong>Browse. Sign up. Log in.</strong></h3>
                    <p class="introduction-text">You are now in Guest mode. You can browse through the dashboard to see what kind of services we offer. If you want to manage your own projects in Cyso Cloud you have to sign up or log in.</p>
                    <router-link :to="{name: 'sign-up'}" class="btn btn-lg btn-cta mt-3">Sign up</router-link>
                    <p class="mt-4 mb-0">
                        <router-link :to="{name: 'login'}">Log in</router-link>
                    </p>
                </div>
            </div>
            <b-row class="mt-5">
                <b-col sm="8">
                    <h3>Create</h3>
                    <b-row tag="ul" class="list-unstyled quick-link">
                        <f-object-store/>
                    </b-row>
                    <h3 class="mt-5">After Instance creation</h3>
                    <b-row tag="ul" class="list-unstyled quick-link">
                        <f-block-store/>
                        <f-snapshot/>
                        <f-ips/>
                    </b-row>
                </b-col>
                <b-col sm="4">
                    <h3>Learn More</h3>
                    <ul class="list-unstyled quick-link academy-link">
                        <li>
                            <a href="https://cyso.cloud/docs/getting-started" target="_blank" rel="noopener noreferrer">
                                <p>Getting Started</p>
                                <p>Follow this guide to learn the basics.</p>
                            </a>
                        </li>
                        <li>
                            <a href="https://cyso.cloud/docs/fuga-cloud-cli" target="_blank" rel="noopener noreferrer">
                                <p>OpenStack CLI</p>
                                <p>Learn the basics of the OpenStack CLI</p>
                            </a>
                        </li>
                        <li>
                            <a href="https://cyso.cloud/docs/ansible" target="_blank" rel="noopener noreferrer">
                                <p>Ansible and Fuga</p>
                                <p>Simple IT Automation</p>
                            </a>
                        </li>
                        <li>
                            <a href="https://cyso.cloud/docs/" target="_blank" rel="noopener noreferrer">
                                <p>Other tutorials</p>
                                <p>Learn.Build.Deploy</p>
                            </a>
                        </li>
                    </ul>
                </b-col>
            </b-row>
        </b-card>
        <div class="card" v-if="hasCustomer">
            <h2>Invoices
                <b-form-select id="customer" class="customer--selection" v-model="selectedCustomer" name="customer" v-if="customers.length > 1">
                    <option v-for="(customer, index) in customers" :key="index" :value="customer">{{ customer.name }}</option>
                </b-form-select>
                <span v-else>{{ selectedCustomer.name }}</span>
            </h2>
            <fInvoiceChart :selectedCustomerId="selectedCustomer.id" :key="selectedCustomer.id" />
        </div>
    </div>
</template>

<script>
import fQuota from '@/components/f-quota';
import fObjectStore from '@/components/products/f-object-store';
import fBlockStore from '@/components/products/f-volume-store';
import fSnapshot from '@/components/products/f-snapshot';
import fIps from '@/components/products/f-ips';
import fProjectHeader from '@/components/f-project-header';
const svgRocketLaunch = () => import('@/components/svg/svg-rocket');
import fChartData from '@/components/charts/f-chart-data';
import fInvoiceChart from '@/components/charts/f-invoice-chart';
import fUsageCards from '@/components/f-usage-cards';

export default {
    data() {
        return {
            isFuga: localStorage.getItem('isFuga') ? true : false,
            selectedCustomer: false,
        };
    },

    computed: {
        emk() {
            return this.$store.state.emk;
        },

        customers() {
            let data = this.$store.state.customer.list;
            if (data[0]) {
                this.selectedCustomer = data[0];
            }
            // data = [{"accounting_provider_foreign_id":"85fbff93-7577-455c-a227-7960101d1242","address":"Vogelzangstraat 21","area":"","cancelled_at":null,"city":"Heerhugowaard","country":"NL","created_at":"2018-10-31T08:04:40.656583+00:00","credit_balance":100,"email_address":"marino@fuga.cloud","id":"217c60da-df8d-4743-aa22-4ba125287e75","max_teams":10,"name":"Marino Dekker","owner":{"email_address":"marino@fuga.cloud","first_name":"Marino","id":"2597f069-0860-4184-a771-f855735a1b17","last_name":"Dekker"},"payment_methods":["d4a4e076-88e8-4f40-bbcf-da1dafe79ce0","fef3f4cf-d5c0-4251-a517-de219fad6bf7"],"payment_provider_foreign_id":"cus_JgecZSSYAfaJuY","phone_number":"0725715676","postal_code":"1703KS","prepaid_balance":0,"risk_score":0,"status":"active","stripe_payment_provider_foreign_id":"cus_JgecZSSYAfaJuY","subscription_status":null,"teams":["47cceca7-c89d-4fd1-aaa0-a09a20b01021","9f2a82d4-c406-48fc-b8bc-46a83c400c2e","e0075c1c-dcaf-46b4-afee-b2dd29eabd6e","6d02ce91-4b3c-4357-a57a-f5931dc414d2","bbe7ca30-2b78-4173-a752-7768a1b42664","6ddc91b7-7c8c-4cd1-b407-bb6a087cd814","ce546c04-bef8-40a4-bb51-fb66845faf01","a323ba17-3422-4cc6-a31a-65e72f2aa15d"],"updated_at":"2022-03-21T16:41:55.935448+00:00","vat_id_number":null},{"accounting_provider_foreign_id":"71b98298-32f1-448c-947f-09f196c7fdba","address":"Wognumsebuurt 3","area":"","cancelled_at":null,"city":"Alkmaar","country":"NL","created_at":"2019-04-09T13:00:23.151515+00:00","credit_balance":0,"email_address":"team@fuga.cloud","id":"de988343-b9ee-45ff-b0f1-1db811a5e769","max_teams":5,"name":"Cyso Cloud BV","owner":{"email_address":"paul@fuga.cloud","first_name":"Paul","id":"a2e004b5-fc02-4460-932c-ba72ea036f61","last_name":"Bankert"},"payment_methods":[],"payment_provider_foreign_id":"71b98298-32f1-448c-947f-09f196c7fdba","phone_number":"+31727513408","postal_code":"1817BH","prepaid_balance":0,"risk_score":10,"status":"active","stripe_payment_provider_foreign_id":null,"subscription_status":null,"teams":["cb0fb696-d2fe-4e6b-b8a0-3c802f477f2f","9063c99d-1da9-4023-b0d4-2c11dd3100f8","0837f396-5149-42bd-a0a4-e367a79ca751","6c793fd8-9650-4f38-bb7f-d4bbcb6c4f31","bf938c95-4d84-471d-b0b3-d36483f7ddc7"],"updated_at":"2023-03-30T15:14:18.084673+00:00","vat_id_number":"NL855935984B01"}]
            return data;
        },
    },

    components: {
        fQuota,
        fObjectStore,
        fBlockStore,
        fSnapshot,
        fIps,
        fProjectHeader,
        svgRocketLaunch,
        fChartData,
        fInvoiceChart,
        fUsageCards,
    },
}
</script>
<style scoped="scoped">

.news {
  display: flex;
  flex-wrap: wrap;
}
.news article {
    width: 18.4%;
    margin: 10px 1%;
    padding: 0;
}
.news article:first-child {
  margin-left: 0;
}
.news article:last-child {
  margin-right: 0;
}
.news article > a {
    color: inherit;
    height: 100%;
    width: 100%;
    display: block;
    padding: 20px;
}
.article__summary--hero {
    width: 100%;
}
.news__title {
    font-size: 14px;
    font-weight: 800;
}
.news article > a:hover {
  background: linear-gradient(to bottom,rgba(36,47,75,.13) 0,#393f49 100%),#184898;
  color: #fff;
  text-decoration: none;
  overflow: hidden;
}
.news article > a:hover .news__title {
  color: #fff;
}
.article__summary--text {
    max-height: 100px;
    overflow: hidden;
}
.article__summary--hero {
    margin: -20px -20px 0 -20px;
    width: calc(100% + 40px);
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
    transition: transform .2s;
    max-width: unset;
}
.news article > a:hover .article__summary--hero {
    transform: scale(1.03);
}
.customer--selection {
    width: 300px;
}
</style>
